<div class="flex-1">
  <h2 class="mt-0">Sendungsverfolgung NEW</h2>
  @if (loading()) {
    <mat-spinner [diameter]="50"></mat-spinner>
  }
  @if (tours().length === 0 && !loading()) {
    <p class="flex-grow-1">Zur Zeit ist keine Lieferung unterwegs.</p>
  }
  @if (tours().length > 0 && !loading()) {
    <table mat-table [dataSource]="tours()" class="mat-elevation-z0">

      <ng-container matColumnDef="tour">
        <th mat-header-cell *matHeaderCellDef>Tour</th>
        <td mat-cell *matCellDef="let item">
          {{ getDepartureTimeAndStation(item.tour_id) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="arrival">
        <th mat-header-cell *matHeaderCellDef>Voraussichtliche Ankunft</th>
        <td mat-cell *matCellDef="let item">
          @if (!item.delivered_at && item.expected_time_of_arrival_max) {
            <p [class]="checkDelay(item)">
              {{ item.expected_time_of_arrival_min | date:'shortTime' }}
              - {{ item.expected_time_of_arrival_max | date:'shortTime' }}
            </p>
          }
          @if (!item.expected_time_of_arrival_max && !item.delivered_at) {
            <p>
              {{ item.planned_time_of_arrival | arrivalRangePipe }}
            </p>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let item">
          @let delayStatus = checkDelay(item);

          <span class="badge badge-pill" [ngClass]="'badge-' + delayStatus">
            @switch (delayStatus) {
              @case ('time') { pünktlich }
              @case ('time alerting') { leicht verspätet }
              @case ('time warning') { verspätet }
            }
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  }
</div>
@if (!loading()) {
  <a class="widget-link mt-m" routerLink="/sendungsverfolgung-new">Tourendetails ></a>
}
